import ActionTypes from "../../../constants/ActionTypes";
import { ISetTransactionStatusAction, ISetTransactionAction, ICancelTransactionAction, ITransactionCancelData, IFetchTransactionWithHashAction, IFetchTransactionWithSaidAction, ITransactionCancelPre2PostData, ICancelTransactionPre2PostAction } from "./types";
import { ITransaction } from '../../../entities/checkout/transaction/types';

export const fetchTransactionWithHash = (secretKey: string): IFetchTransactionWithHashAction => {
  return {
    type: ActionTypes.TRANSACTION.FETCH_TRANSACTION_WITH_HASH,
    params: { 'secret': secretKey }
  };
};

export const fetchTransactionWithSad = (said: string): IFetchTransactionWithSaidAction => {
  return {
    type: ActionTypes.TRANSACTION.FETCH_TRANSACTION_WITH_SAID,
    params: { 'said': said }
  };
};

export const updateTransactionStatus = (status: string): ISetTransactionStatusAction => {
  return {
    type: ActionTypes.TRANSACTION.SET_TRANSACTION_STATUS,
    payload: status,
  };
};

export const setTransaction = (transaction: ITransaction): ISetTransactionAction => {
  return {
    type: ActionTypes.TRANSACTION.SET_TRANSACTION,
    payload: transaction,
  };
};

export const cancelTransaction = (cancelData: ITransactionCancelData): ICancelTransactionAction=> {
  return {
    type: ActionTypes.TRANSACTION.CANCEL_TRANSACTION,
    payload: cancelData
  };
};


export const cancelPre2PostAction = (cancelData: ITransactionCancelPre2PostData): ICancelTransactionPre2PostAction=> {
  return {
    type: ActionTypes.TRANSACTION.CANCEL_P2P_TRANSACTION,
    payload: cancelData
  };
};
